const defaultParamsUpdatePricingStatus = {
  isVirtualApplication: false,
  type: 'LoanApplicationIdentifier',
};

export class ApplicationPricingStatusApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async updatePricingStatus(params, options = {}) {
    const queryParams = options.include?.length
      ? `?${options.include.map(item => `include=${item}`).join('&')}`
      : '';

    // The loan-editor pricing panel is a secondary read that a subtree-scoped TPO broker is not
    // authorized for; a 403 here must degrade the panel, not trigger the global page reload loop
    // (DEV-4226). skipResponseInterceptor.forbiddenError lets the rejection surface to the caller.
    return this.#http.post(
      `/api/applications/pricingStatus${queryParams}`,
      {
        ...defaultParamsUpdatePricingStatus,
        ...params,
      },
      { skipResponseInterceptor: { forbiddenError: true } },
    );
  }

  async calculateLockExtensionCost(params) {
    return this.#http.post('/api/applications/lock-desk/lock-extension/cost-calculation', {
      context: {
        ...defaultParamsUpdatePricingStatus,
        ...params.context,
      },
      lockExtensionDays: params.lockExtensionDays,
    });
  }
}
